import { render, staticRenderFns } from "./ResultadoIndicadores.vue?vue&type=template&id=769ba13b&scoped=true"
import script from "./ResultadoIndicadores.vue?vue&type=script&lang=js"
export * from "./ResultadoIndicadores.vue?vue&type=script&lang=js"
import style0 from "./ResultadoIndicadores.vue?vue&type=style&index=0&id=769ba13b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769ba13b",
  null
  
)

export default component.exports